import * as React from 'react';
import { GOOGLE_AUTH_POPUP_MESSAGE } from '../../../common/googleAuthFlow';

export type LoginPopupProps = {
    location: string
    onUserClosePopup?: () => void
    onPopupClose?: () => void
    onRegistrationRequired?: () => void
    onEmailConflict?: () => void
    onExistingAccountEmailUnverified?: () => void
}

export class LoginPopup extends React.Component<LoginPopupProps> {
    popup: Window | null = null;

    closeWatcher?: number;

    componentDidMount() {
        this.open();
    }

    componentWillUnmount(): void {
        window.removeEventListener('message', this.receiveMessage);
        if (this.closeWatcher) {
            window.clearInterval(this.closeWatcher);
        }
    }

    receiveMessage = (event: MessageEvent) => {
        if (event.origin !== window.location.origin || event.source !== this.popup) return;

        if (event.data === GOOGLE_AUTH_POPUP_MESSAGE.SUCCESS) {
            this.popup?.close();
            this.props.onPopupClose?.();
            return;
        }

        if (event.data === GOOGLE_AUTH_POPUP_MESSAGE.REGISTRATION_REQUIRED) {
            this.popup?.close();
            this.props.onRegistrationRequired?.();
            return;
        }

        if (event.data === GOOGLE_AUTH_POPUP_MESSAGE.EMAIL_CONFLICT) {
            this.popup?.close();
            this.props.onEmailConflict?.();
            return;
        }

        if (event.data === GOOGLE_AUTH_POPUP_MESSAGE.EXISTING_ACCOUNT_EMAIL_UNVERIFIED) {
            this.popup?.close();
            this.props.onExistingAccountEmailUnverified?.();
        }
    };

    open() {
        // TODO : solve www.domain.com with popup (cross origin error cause the popup is on domain.com)
        const popupWidth = 1000;
        const popupHeight = 800;
        const xPosition = (window.innerWidth - popupWidth) / 2;
        const yPosition = (window.innerHeight - popupHeight) / 2;

        this.popup = window.open(window.location.origin + this.props.location, 'התחברות', `${'location=1,scrollbars=1,'
            + 'width='}${popupWidth},height=${popupHeight},`
            + `left=${xPosition},top=${yPosition}`,
        );

        window.addEventListener('message', this.receiveMessage);
        this.closeWatcher = window.setInterval(() => {
            if (this.popup?.closed) {
                if (this.closeWatcher) {
                    window.clearInterval(this.closeWatcher);
                    this.closeWatcher = undefined;
                }
                if (this.props.onUserClosePopup) {
                    this.props.onUserClosePopup();
                }
            }
        }, 500);
    }

    render() {
        return null;
    }
}
